module.exports = __webpack_public_path__ + "img/yogyagroup.d82243bb.png";